export const INFINITY_SNOOZE_THRESHOLD = 24 * 60 * 60;
export const CALL_STATE_TRANSITION_DURATION = 2000;
export const CALL_NOTIFICATION_DURATION = 5000;
export const AUDIO_INPUT_DEVICE_KEY = '_audio_input_device';

export const EXPLICIT_INTEGRATION_SOURCE = {
    I2X_CALL_EVENT: 1,
    UCT_CALL_EVENT: 2,
    I2X_MANUAL_CALL_EVENT: 3,
    WIN_AUDIO_SESSION_EVENT: 4,
    COPS_I2X_EVENT: 5,
    ORECX: 6,
    KEYPHRASE_AUDIO_EVENT: 7,
    RECORDER_EVENT: 8
} as const;
